import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=bc6b9b12&scoped=true&"
import script from "./Users.vue?vue&type=script&lang=js&"
export * from "./Users.vue?vue&type=script&lang=js&"
import style0 from "./Users.vue?vue&type=style&index=0&id=bc6b9b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6b9b12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc6b9b12')) {
      api.createRecord('bc6b9b12', component.options)
    } else {
      api.reload('bc6b9b12', component.options)
    }
    module.hot.accept("./Users.vue?vue&type=template&id=bc6b9b12&scoped=true&", function () {
      api.rerender('bc6b9b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/Users.vue"
export default component.exports